import React, { useState } from 'react';
import cx from 'classnames';

import { ISectionWithCollapsiblesFields } from '../../../types/contentful';

import { Collapsible } from '../Collapsible';
import RichText from '../RichText';

interface Props extends ISectionWithCollapsiblesFields {
  fullWidthHeader?: boolean;
  sysId?: string;
}

export function SectionWithCollapsibles({
  headingText,
  dualColumns,
  collapsibles,
  footerContent,
  fullWidthHeader,
  sysId
}: Props) {
  const startingCollapsibles = collapsibles
    ? collapsibles.map(() => 'close')
    : [];
  const [openCollapsibles, setOpenCollapsibles] =
    useState(startingCollapsibles);

  const toggleCollapsible = (index: number) => {
    const newCollapsibles = openCollapsibles.map((collapsible, i) => {
      if (index === i) {
        if (collapsible === 'open') return 'close';
        else return 'open';
      } else {
        return collapsible;
      }
    });
    setOpenCollapsibles(newCollapsibles);
  };

  return (
    <div
      className="block-container"
      data-blockid="sectionWithCollapsibles"
      data-testid="section-with-collapsibles"
      id={sysId}
    >
      <div className="layout !py-0">
        <div className="column w-full flex-col">
          <div className="border-box pb-8">
            {headingText && !fullWidthHeader && (
              <h2 className="heading-2 w-full">{headingText}</h2>
            )}
            {headingText && fullWidthHeader && (
              <h2 className="heading-2 w-full text-left desktop:text-center">
                {headingText}
              </h2>
            )}
          </div>
          <div
            className={cx('', {
              'block tablet:grid tablet:grid-cols-2 tablet:gap-x-8': dualColumns
            })}
          >
            {collapsibles &&
              collapsibles.map(({ sys, fields }, idx: number) => {
                return (
                  fields && (
                    <Collapsible
                      {...fields}
                      key={sys?.id}
                      isOpen={openCollapsibles[idx] === 'open'}
                      onClick={() => toggleCollapsible(idx)}
                    />
                  )
                );
              })}
          </div>
          {footerContent && (
            <div className="pt-8 [&_a]:mr-4">
              <RichText data={footerContent} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
